import { render, staticRenderFns } from "./notify-summons-attendee-modal.vue?vue&type=template&id=3634b7fc&scoped=true&"
import script from "./notify-summons-attendee-modal.vue?vue&type=script&lang=ts&"
export * from "./notify-summons-attendee-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3634b7fc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
